import { render } from "./WaivedBillModal.vue?vue&type=template&id=2bb8779f&scoped=true"
import script from "./WaivedBillModal.vue?vue&type=script&lang=js"
export * from "./WaivedBillModal.vue?vue&type=script&lang=js"

import "./WaivedBillModal.vue?vue&type=style&index=0&id=2bb8779f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb8779f"]])

export default __exports__